export class ProfessionModel {
      
    codigo: string;  
    descripcion: string;      
}


